// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + ({"164":"public-checkout-pallet","203":"view-order","702":"pending-orders"}[chunkId] || chunkId) + "-legacy." + {"164":"4aa4f0e2","203":"3e1ab709","702":"18777d6c","938":"a72a8be1"}[chunkId] + ".js";
};